import { render } from "./RateList.vue?vue&type=template&id=3c3efc34&scoped=true"
import script from "./RateList.vue?vue&type=script&lang=js"
export * from "./RateList.vue?vue&type=script&lang=js"

import "./RateList.vue?vue&type=style&index=0&id=3c3efc34&lang=scss&scoped=true"

import exportComponent from "/var/www/nexgen/apps/nxglabs-web/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c3efc34"]])

export default __exports__